/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-03-25 17:50:08
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-07-13 11:32:33
 */

import Vue from "vue";
import App from "./App.vue";

import Vant from "vant";
import "vant/lib/index.css";
import router from "./router";

import store from "./store";

// 全局js
import global_ from "./utils/global";
Vue.prototype.GLOBAL = global_;

// 图标
import "./assets/iconfont";

// 全局css
import "@/styles/index.scss";

Vue.config.productionTip = false;

Vue.config.devtools = true;

Vue.use(Vant);

import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

Vue.use(VideoPlayer);

new Vue({
	render: (h) => h(App),
	router,
	store,
	components: { App },
}).$mount("#app");
